import { render, staticRenderFns } from "./StarRaceCard.vue?vue&type=template&id=5c13e01f&scoped=true"
import script from "./StarRaceCard.vue?vue&type=script&lang=ts"
export * from "./StarRaceCard.vue?vue&type=script&lang=ts"
import style0 from "./StarRaceCard.vue?vue&type=style&index=0&id=5c13e01f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c13e01f",
  null
  
)

export default component.exports